//GET /images 요청시 실어 보내는 query param 중
//genre key에 대한 value

export enum StandardGenreValueEnum {
  '로맨스' = '로맨스',
  '판타지' = '판타지',
  '액션' = '액션',
  '일상' = '일상',
  '스릴러' = '스릴러',
  '개그' = '개그',
  '남성향 19금' = '남성향 19금',
  '여성향 19금' = '여성향 19금',
  '무협/사극' = '무협/사극',
  '스포츠' = '스포츠',
  '로판' = '로판',
  '현판' = '현판',
  'BL' = 'BL',
  'GL' = 'GL',
  '드라마' = '드라마'
}

export enum AdultsOnlyGenreValueEnum {
  '남성향 19금' = '남성향 19금',
  '여성향 19금' = '여성향 19금'
}
